import { fleetManagementApi } from "../api";

const GENERAL_EXPENSES_ENDPOINT = "/general-expenses";

export const getAllGeneralExpenses = async () => {
  const response = await fleetManagementApi.get(GENERAL_EXPENSES_ENDPOINT);
  return response;
}

export const getGeneralExpenseById = async (generalExpenseId) => {
  const response = await fleetManagementApi.get(`${GENERAL_EXPENSES_ENDPOINT}/${generalExpenseId}`);
  return response;
}

export const createGeneralExpense = async (generalExpenseData) => {
  const response = await fleetManagementApi.post(GENERAL_EXPENSES_ENDPOINT, generalExpenseData);
  return response;
}

export const updateGeneralExpense = async (generalExpenseId, generalExpenseData) => {
  const response = await fleetManagementApi.put(
    `${GENERAL_EXPENSES_ENDPOINT}/${generalExpenseId}`,
    generalExpenseData
  );
  return response;
}

export const deleteGeneralExpense = async (generalExpenseId) => {
  const response = await fleetManagementApi.delete(`${GENERAL_EXPENSES_ENDPOINT}/${generalExpenseId}`);
  return response;
}